import {
  ConditionsReactivateFooterLinkDto,
  FooterLinkRequestDtoProfileEnum,
} from 'lib_api/lib/api/gen';

export type FilterDashboardFooterLink = {
  valid?: boolean;
};

export type FooterLinkFormValue = {
  link?: string;
  text?: string;
  profile?: FooterLinkRequestDtoProfileEnum;
};

export type useActivationFooterLinkReturn = {
  submitDeprecate: (idCorrelation: string) => Promise<Response>;
  submitReactivate: (idCorrelation: string) => Promise<Response>;
  conditionsReactivate: (
    idCorrelation: string,
  ) => Promise<ConditionsReactivateFooterLinkDto>;
};

export const footerLinkProfileValue: FooterLinkRequestDtoProfileEnum[] = [
  FooterLinkRequestDtoProfileEnum.AUTORITE_FOURRIERE,
  FooterLinkRequestDtoProfileEnum.FORCE_DE_L_ORDRE,
  FooterLinkRequestDtoProfileEnum.GARDIEN_FOURRIERE,
];

export const LINK_LABEL = 'Lien';
export const TEXT_LABEL = 'Texte';
export const PROFILE_LABEL = 'Profil';
